import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { GatsbyImage } from "gatsby-plugin-image";
import * as styles from './index.module.css'
import Link from '../Link'

export default class AnimatedIntroImage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      scrollPosition: 0,
      triggerPosition: 0,
      triggered: false,
    }
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll)

    var clientRect = ReactDOM.findDOMNode(this).getBoundingClientRect()
    this.state.triggerPosition = clientRect.top
  }

  handleScroll = () => {
    if (typeof window !== undefined) {
      var windowScrollBottom = window.pageYOffset + window.innerHeight * 0.6

      this.state.scrollPosition = windowScrollBottom

      if (
        windowScrollBottom > this.state.triggerPosition &&
        this.state.triggered == false
      ) {
        this.state.triggered = true
      }

      this.setState(this.state)
    }
  }

  render() {
    var props = this.props
    const { ctaText, ctaUrl } = props
    var info = this.props.subtitle.subtitle.split(';')
    var color = info[0]
    var h3 = info[1]
    var h4 = info[2]
    var p = info[3]

    var image = props.images[0]

    const styleColor = {
      textColor: {
        color: color,
      },
      backgroundColor: {
        backgroundColor: color,
      },
    }

    return (
      <div
        className={
          styles.lightWrapper +
          ' ' +
          (this.state.triggered &&
          typeof window !== `undefined` &&
          window.innerWidth > 450
            ? styles.triggered
            : '')
        }
      >
        <div className="wrapper">
          <div className={styles.container}>
            <GatsbyImage
              image={image.gatsbyImageData}
              className={styles.image}
              imgStyle={{ objectFit: 'contain' }}
              alt={image.title || image.description} />

            <div className={styles.info}>
              <h2>{props.title}</h2>
              <div className={styles.secondaryInfo}>
                <h3>{h3}</h3>
                <h4 style={styleColor.textColor}>{h4}</h4>
                <p>{p}</p>
                <Link to={ctaUrl} style={styleColor.backgroundColor}>
                  {ctaText}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
